import * as React from "react";
import { useMemo } from "react";
import { Link, matchPath, useLocation } from "react-router-dom";
import { classNames } from "src/common/classNames";
import { makeUrl } from "src/routes/makeUrl";
import { PageUrl } from "src/routes/PageUrl";

import * as styles from "../LeftMenu.module.less";
import {
  leftMenuActivePartitions,
  PartitionUrl,
} from "../leftMenuActivePartitions";
import { LeftMenuInternalLinkItem } from "../LeftMenuItem";

export type PropsInternalLinkItem = {
  item: LeftMenuInternalLinkItem;
  onClick: () => void;
};

export const InternalLinkItem: React.FC<PropsInternalLinkItem> = (props) => {
  const { item, onClick } = props;
  const { pathname } = useLocation();
  const active = useMemo(
    () => isActiveItem(item.url, pathname),
    [item, pathname],
  );
  return (
    <Link
      to={makeUrl(item.url)}
      className={classNames([styles.menuItem, [active, styles.active]])}
      onClick={(e) => {
        e.stopPropagation();
        onClick();
      }}
    >
      {item.icon}
      <span className={styles.label}>{item.label}</span>
    </Link>
  );
};

const isActiveItem = (itemPart: PartitionUrl, pathname: string): boolean => {
  const page2part = Object.entries(leftMenuActivePartitions) as [
    PageUrl,
    PartitionUrl,
  ][];
  const pair = page2part.find(
    ([page]) => matchPath(makeUrl(page), pathname) !== null,
  );
  if (!pair) return false;
  const [, part] = pair;
  return itemPart === part;
};
